import { render } from "./NetworkBackground.vue?vue&type=template&id=2a3180ba&scoped=true&ts=true"
import script from "./NetworkBackground.vue?vue&type=script&lang=ts"
export * from "./NetworkBackground.vue?vue&type=script&lang=ts"

import "./NetworkBackground.vue?vue&type=style&index=0&id=2a3180ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3180ba"]])

export default __exports__